if ($('form.searchForm').length) {

  var query = [], checkboxes = [];

  // Clear out form fields if switching between normal and advanced filter forms.
  const advanceFilterButtons = $('.js-advanced-filter');
  if (advanceFilterButtons.length) {
    advanceFilterButtons.each(function (i, el) {
      const button = $(el).find('.js-advanced-filter__btn');
      const buttonClose = el.parentElement.querySelector('.js-advanced-filter__btn--close');

      button.on('click', () => {
        resetAllFields();
      });

      buttonClose.addEventListener('click', () => {
        resetAllFields();
      });
    });
  }

  function resetAllFields() {
    $('form.searchForm').each(function () {
      resetSelects($(this));
      resetCheckboxes($(this));
      resetTextFields($(this));
    });
  }

  function resetTextFields(formEl) {
    query = [];
    var el = formEl.find('select,input[type=text]');
    el.val(null);
    el.closest('form.searchForm').find('input[type=hidden].filterSelections').val(createQuery());
  }

  function resetSelects(formEl) {
    formEl.find(".form-select").each(function () {
      var str = $(this).find(".choices").attr("aria-activedescendant");
      if (str === undefined) { return; }
      str = str.substring(0, str.length - 1) + "2";
      $(this).find(".choices").attr("aria-activedescendant", str);
      var dropdown = $(this).find(".choices__list.choices__list--dropdown .choices__list").first();
      dropdown.find(".choices__item").each(function () {
        $(this).removeClass("is-highlighted").removeAttr("aria-selected");
      });

      dropdown.find(".choices__item--selectable").first().addClass("is-highlighted").attr("aria-selected", "true");
      var value = dropdown.find(".choices__item").first().attr("data-value");
      var text = dropdown.find(".choices__item").first().text();

      $(this).find(".form-select-input option").first().attr("value", value).text(text);
      $(this).find(".choices__list--single .choices__item--selectable").first().attr("data-id", 1).attr("data-value", value).text(text);
    });
  }
  
  function resetCheckboxes(formEl) {
    formEl.find(".custom-control-input:checked").each(function () {
      $(this).prop("checked", false);
    });
    formEl.find("#filterSelections").first().attr("value", null);
    checkboxes = [];
  }

  $('form.searchForm').each(function () {
    $(this).find('select,input[type=text]').on('change', function () {
      getArray(this);
      $(this).closest('form.searchForm').find('input[type=hidden].filterSelections').val(createQuery());
    });

    $(this).find('.form-date-picker').bind('input propertychange', function () {
      getArray(this);
      $(this).closest('form.searchForm').find('input[type=hidden].filterSelections').val(createQuery());
    });

    $(this).find('input[type=checkbox]').on('change', function () {
      if (checkboxes.length) {
        var dirty = false;
        for (var i = 0; i < checkboxes.length; i++) {
          if (checkboxes[i].indexOf("=" + this.value) > -1) {
            dirty = true;
            if (this.checked) {
              checkboxes[i] = this.id + "=" + this.value;
            } else {
              checkboxes.splice(i, 1);
            }
          }
        }
        if (!dirty) {
          checkboxes.push(this.id + "=" + this.value);
        }
      } else {
        checkboxes.push(this.id + "=" + this.value);
      }
      $(this).closest('form.searchForm').find('input[type=hidden].filterSelections').val(createQuery());
    });
  });

  function getArray(field) {
    if (query.length) {
      var dirty = false;
      var regex = new RegExp(field.id.slice(0, -4) + '\\d{4}=');
      for (var i = 0; i < query.length; i++) {
        if (regex.test(query[i])) {
          dirty = true;
          query[i] = field.id + "=" + field.value;
        }
      }
      if (!dirty) {
        query.push(field.id + "=" + field.value);
      }
    } else {
      query.push(field.id + "=" + field.value);
    }
  }

  function createQuery() {
    var queries = '';
    for (var i = 0; i < query.length; i++) {
      if (!queries.length) {
        queries = query[i];
      } else {
        queries += '&' + query[i];
      }
    }

    for (var i = 0; i < checkboxes.length; i++) {
      if (!queries.length) {
        queries = checkboxes[i];
      } else {
        queries += '&' + checkboxes[i];
      }
    }
    return queries;
  }
}
